<template>
	<div class="w1200 flex flex-direction align-stretch benben-flex-layout bind">
	    <div class="flex bind_1">
	    	<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(1)">
	    		<img class="bind_1_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
	    		<div class="bind_1_2">{{$t('返回')}}</div>
	    	</div>
	    </div>
		<div class="topUpPay_1">{{$t('饭票充值')}}</div>
		<div class="flex flex-direction flex-wrap align-center benben-flex-layout topUpPay_5">
			<div class="flex">
				<div class="topUpPay_2">$</div>
				<div class="topUpPay_3">{{payItem.order_money}}</div>
			</div>
			<div class="topUpPay_4">{{$t('支付金额')}}</div>
			<div @click="pay_id = 1" class="flex flex-wrap align-center justify-center benben-flex-layout pointer" :class="pay_id == 1 ? 'topUpPay_6s' : 'topUpPay_6'">
				<img class="topUpPay_6_1" src="https://api.ezlunch.club/pc/image/30.png" alt="" srcset="">
				<div class="topUpPay_6_2">{{$t('微信支付')}}</div>
			</div>
			<div @click="pay_id = 2" class="flex flex-wrap align-center justify-center benben-flex-layout pointer"  :class="pay_id == 2 ? 'topUpPay_6s' : 'topUpPay_6'">
				<img class="topUpPay_6_1" src="https://api.ezlunch.club/pc/image/31.png" alt="" srcset="">
				<div class="topUpPay_6_2">{{$t('支付宝支付')}}</div>
			</div>
			<div class="topUpPay_7 pointer" @click="lijiPay">{{$t('确定')}}</div>
		</div>
		<!-- <div class="codeQr_1">
			<img class="codeQr_2" src="https://api.ezlunch.club/pc/image/17.png" alt="" srcset="">
		</div>
		<div class="codeQr_3">{{$t('微信扫码支付')}}</div>
		<div class="codeQr_3">{{$t('支付宝扫码支付')}}</div>
		<div class="flex flex-direction flex-wrap align-center benben-flex-layout">
			<img class="topUpPay_8" src="https://api.ezlunch.club/pc/image/28.png" alt="" srcset="">
			<div class="topUpPay_9">{{$t('支付成功')}}</div>
			<div class="topUpPay_10">到账{{payItem.num_s}}张{{payItem.name_s}}</div>
			<div class="topUpPay_11 pointer" @click="caozuo(2)">{{$t('返回个人中心')}}</div>
		</div> -->
		
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				pay_id:1,
				payItem:'',
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				if (window.sessionStorage.getItem('payItem')) {
					this.payItem = JSON.parse(window.sessionStorage.getItem('payItem'))
				}
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			console.log(this.payItem,1111111111)
		},

		methods: {
			gengxin(){
				
			},
		

			lijiPay(){
				// let url = "https://checkout.stripe.com/c/pay/cs_test_a1u3mu4CLhcUpW4ynLPQWPefpEXqvqVbFrNeOepIbD5nvsrKq4aD848dl0#fidnandhYHdWcXxpYCc%2FJ2FgY2RwaXEnKSdkdWxOYHwnPyd1blpxYHZxWjA0VlRvUlBDYkIzZGhRaW9mdjVWcl88a1dwc3V9bWRONkZJSV8wbUowbWdXMUFfMWhHfGh2TndiYDJua2RQSUhDfDN2QTV1cndwM2xzQF1WRFBDXFBOcnExNTVQSjJEaj10fScpJ2N3amhWYHdzYHcnP3F3cGApJ2dkZm5id2pwa2FGamlqdyc%2FJyZjY2NjY2MnKSdpZHxqcHFRfHVgJz8ndmxrYmlgWmxxYGgnKSdga2RnaWBVaWRmYG1qaWFgd3YnP3F3cGB4JSUl"

				// window.location.href = url
				// return
				this.$api.post(this.$apiUrls.post693f840684f1a,{
					order_sn:this.payItem.order_sn,
					source:'pc',
					payment_method:this.pay_id == 1 ? 'wechat_pay' : 'aliypay'
				}).then((res) => {
					console.log(res,124)
					// return
					if(res.code == 1){
						let urls = res.data.pay_url
						window.location.href = urls
						// window.history.back();
						// return
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type){
				if(type == 1){
					window.history.back();
					return
				}else if(type == 2){
					this.$router.push({
						name: 'myinfo',
					});
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		
	}
	.bind{
		margin-top: 20px;
		padding: 0 20px 100px;
		background: #fff;
	}
	.bind_1{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.bind_1_1{
		width: 14px;
		height: 14px;
	}
	.bind_1_2{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-left: 10px;
	}
	.topUpPay_1{
		font-weight: 500;
		font-size: 16px;
		color: #1A1A1A;
		margin: 27px 0 0 0;
	}
	.topUpPay_2{
		font-weight: 500;
		font-size: 20px;
		color: #1A1A1A;
		margin: 12px 0 0 0;
	}
	.topUpPay_3{
		font-weight: 500;
		font-size: 32px;
		color: #1A1A1A;
	}
	.topUpPay_4{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin: 16px 0 0 0;
	}
	.topUpPay_5{
		margin: 120px 0 0 0;
	}
	.topUpPay_6{
		margin: 32px 0 0 0;
		padding: 17px 40px;
		background: #F6F7F9;
		border-radius: 8px 8px 8px 8px;
		min-width: 200px;
		border: 1px solid #F6F7F9;
	}
	.topUpPay_6s{
		margin: 32px 0 0 0;
		padding: 17px 40px;
		background: #FFF7F2;
		border-radius: 8px 8px 8px 8px;
		min-width: 200px;
		border: 1px solid #FF7721;
	}
	.topUpPay_6_1{
		width: 30px;
		height: 30px;
	}
	.topUpPay_6_2{
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		margin: 0 0 0 8px;
	}
	.topUpPay_7{
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		height: 48px;
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		line-height: 48px;
		margin: 40px 0px 0 0;
		width: 200px;
		text-align: center;
	}
	.codeQr_1{
		width: 242px;
		height: 242px;
		margin: 170px auto 20px;
		border: 1px dashed #000;
	}
	.codeQr_2{
		width: 240px;
		height: 240px;
	}
	.codeQr_3{
		font-weight: bold;
		font-size: 20px;
		color: #333333;
		text-align: center;
	}
	.topUpPay_8{
		width: 88px;
		height: 88px;
		margin: 110px auto 0;
	}
	.topUpPay_9{
		font-weight: 500;
		font-size: 16px;
		color: #333333;
		margin: 14px 0 0 0;
	}
	.topUpPay_10{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin: 16px 0 0 0;
	}
	.topUpPay_11{
		height: 42px;
		background: #F3F3F3;
		border-radius: 6px 6px 6px 6px;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		line-height: 42px;
		padding: 0 22px;
		margin: 86px 0 0 0;
	}
</style>